import React from 'react';
import styles from '../styles';
import useMediaQuery from '../hooks/useMediaQuery';
import { useLanguage } from '../contexts/LanguageContext';
import { FaShieldAlt } from 'react-icons/fa';

const GDPRCompliance = () => {
    const isMobile = useMediaQuery('(max-width: 768px)');
    const { t } = useLanguage();

    const gdprStyles = {
        container: {
            ...styles.section,
            backgroundColor: '#e9ecef', // Slightly darker grey than #f8f9fa
            padding: isMobile ? '3rem 1rem' : '4rem 2rem',
        },
        content: {
            maxWidth: '800px',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        icon: {
            fontSize: '4rem',
            color: '#28a745', // Green for compliance/safety
            marginBottom: '1.5rem',
        },
        headline: {
            ...styles.h2,
            marginBottom: '1rem',
        },
        body: {
            ...styles.bodyText,
            color: '#495057',
        }
    };

    return (
        <section style={gdprStyles.container}>
            <div style={gdprStyles.content}>
                <FaShieldAlt style={gdprStyles.icon} />
                <h2 style={gdprStyles.headline}>{t('gdpr.headline')}</h2>
                <p style={gdprStyles.body}>
                    {t('gdpr.body')}
                </p>
            </div>
        </section>
    );
};

export default GDPRCompliance;
